import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";
import StudentWriting from "./student/StudentWriting";
import TeacherWriting from "./teacher/TeacherWriting";

export default function Writing() {
	const role = useAppSelector((state) => state.user.role);

	return role === UserRole.Writer ? <StudentWriting /> : <TeacherWriting />;
}
